import {Box, Skeleton} from "@mui/material";

interface IMediaSkeletonProps {
    width?: string | number;
    height?: string | number;
    borderRadius?: string;
    aspectRatio?: string;
}

export const MediaSkeleton = ({
    width = '100%',
    height,
    borderRadius = '8px',
    aspectRatio
}: IMediaSkeletonProps) => {
    return (
        <Box
            sx={{
                width,
                height,
                aspectRatio,
                borderRadius,
                overflow: 'hidden'
            }}
        >
            <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="wave"
                sx={{
                    borderRadius,
                    transform: 'none'
                }}
            />
        </Box>
    );
};
